import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const IG_NAME_ANNOTATION = 'cloud.google.com/instance-group';

const gcpInstanceGroupContent = EntityContentBlueprint.make({
  name: 'gcp-instance-group',
  params: {
    path: '/instance-group',
    title: 'Instance Group',
    group: 'operation',
    filter: entity =>
      entity.kind.toLocaleLowerCase('en-US') === 'component' &&
      Boolean(entity.metadata.annotations?.[IG_NAME_ANNOTATION]),
    loader: () =>
      import('./GcpInstanceGroupContent').then(m => (
        <m.GcpInstanceGroupContent />
      )),
  },
});

export const gcpInstanceGroupModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [gcpInstanceGroupContent],
});
